import SearchBar from 'modules/search-bar/components/search-bar'
import PropTypes from 'prop-types'
import { Component, Fragment } from 'react'
import withWindowScroll from 'shared/components/gif-grid/with-window-scroll'
import Login from 'shared/components/login'
import Message from 'shared/components/message/flash-message'
import PromoMessage from 'shared/components/promo-message'
import UserContext from 'shared/contexts/user'
import useWindowSize from 'shared/hooks/window-size'
import styled from 'styled-components'
import CreationButtons from './creation-buttons'
import FloatingLinks from './floating-links'
import GlobalMessageManager from './global-message-manager'
import css from './header.css'
import Logo from './logo'
import Menu from './menu'

const STICKY_NAV_TOGGLE_POSITION = 62

const Container = styled.div`
    margin-left: auto;
    margin-right: auto;
    width: 1040px;
`

const PromoTitle = styled.span`
    font-size: 20px;
    font-weight: 900;
`

const PromoBody = styled.span`
    font-size: 15px;
`

const NewPill = styled.img`
    position: relative;
    padding: 0px 8px;
`

const menuItems = ['reactions', 'entertainment', 'sports', 'stickers', 'artists']

const SearchWithWindowHeight = ({ searchTerm }) => {
    const { innerHeight } = useWindowSize()
    return <SearchBar isDesktop appHeight={innerHeight} isFixed searchTerm={searchTerm} />
}

@withWindowScroll(20)
export default class Header extends Component {
    static propTypes = {
        showSearch: PropTypes.bool,
        showBrowse: PropTypes.bool,
        searchTerm: PropTypes.string,
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        const shouldBeSticky = nextProps.scrollTop >= STICKY_NAV_TOGGLE_POSITION
        if (shouldBeSticky !== prevState.isSticky) {
            return { isSticky: shouldBeSticky }
        }
        return null
    }
    static contextType = UserContext
    state = {
        isSticky: false,
    }
    render() {
        const { showSearch, showBrowse, searchTerm, hideLogo = false } = this.props
        const { isSticky } = this.state
        const {
            user: { isArtist, isPartner, permissions },
        } = this.context

        const canViewDashboardTrendingSearches = permissions && permissions.dashboard_analytics

        return (
            <Fragment>
                <GlobalMessageManager />
                <Message isDesktop />
                {canViewDashboardTrendingSearches ? (
                    <PromoMessage
                        storageLabel="has-seen-dashboard-trending-searches-v1-banner"
                        linkUrl="/dashboard?source=banner"
                        linkLabel="Open Dashboard"
                        titleEmoji="🔥"
                    >
                        <PromoTitle>Search Insights</PromoTitle>
                        <NewPill src="/static/img/svg/pill-new.svg" alt="" />
                        <PromoBody>
                            Your dashboard now has search insights that will take your content creation to the next
                            level.
                        </PromoBody>
                    </PromoMessage>
                ) : isArtist ? (
                    <PromoMessage
                        storageLabel="has-seen-portfolios-banner"
                        linkLabel="View Settings"
                        isPortfolios={true}
                    >
                        <PromoTitle>Available For Work? </PromoTitle>
                        <PromoBody style={{ marginLeft: `14px`, paddingTop: `2px` }}>
                            Display Your Work Availability To Brands, Businesses and Talent on GIPHY.
                            <a
                                href="https://support.giphy.com/hc/en-us/articles/360051709851-Freelance-GIF-Artist-Guide"
                                style={{ color: `#fff`, marginLeft: `5px` }}
                            >
                                {' '}
                                Learn More
                            </a>
                        </PromoBody>
                    </PromoMessage>
                ) : isPartner ? (
                    <PromoMessage
                        storageLabel="has-seen-partners-banner"
                        linkUrl="/artists"
                        linkLabel="View Artist Directory"
                    >
                        <PromoTitle>Looking to Hire an Artist?</PromoTitle>
                        <NewPill src="/static/img/svg/pill-new.svg" alt="" />
                        <PromoBody>Browse & contact GIF Artists looking for their next project!</PromoBody>
                    </PromoMessage>
                ) : (
                    <PromoMessage
                        storageLabel="has-seen-supercut-banner"
                        linkUrl="/supercut"
                        linkLabel="Open Super Cut"
                    >
                        <PromoTitle>GIPHY Super Cut: </PromoTitle>
                        <NewPill src="/static/img/svg/pill-new.svg" alt="" />
                        <PromoBody>Bulk GIF creation for our most cherished partners.</PromoBody>
                    </PromoMessage>
                )}
                <div className={showSearch ? css.navPlaceholderSearch : css.navPlaceholder} data-sticky={isSticky} />
                <div className={css.headerWrapper} data-sticky={showSearch && isSticky}>
                    <div id="header" className={css.container}>
                        <Container itemScope itemType="http://schema.org/Organization">
                            {!hideLogo && <Logo />}
                            {showBrowse && <Menu items={menuItems} />}
                            {showBrowse && <CreationButtons />}
                            <Login />
                        </Container>
                    </div>
                    {showSearch && (
                        <div className={css.searchbarWrapper}>
                            <Container id="searchbar" className={`${css.searchbar}`}>
                                <SearchWithWindowHeight searchTerm={searchTerm} />
                            </Container>
                        </div>
                    )}
                </div>
                <FloatingLinks />
            </Fragment>
        )
    }
}
